import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CardContainer, Header } from "routes/createContent/components/styles";
import { LibraryItem } from "../../components/LibraryItem/LibraryItem";
import { LogoIcon } from "assets";
import { useHistory } from "react-router-dom";
import { Box, Button, CircularProgress, TablePagination, TextField } from "@material-ui/core";
import { LocaleSelect } from "routes/createContent/components/LocaleSelect";
import { Add } from "@material-ui/icons";
import { Area } from "types";
import { useGetLessons } from "../../api/useGetLessons";
import { isUsMarket } from "utils/market";

export const Lessons: React.VFC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [locale, setLocale] = useState(isUsMarket ? "en-US" : "sv-SE");
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(25);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    setCurrentPage(0);
  }, [debouncedSearchTerm]);

  const {
    data = {
      items: [],
      metadata: {
        total_count: 0,
      },
    },
    isLoading,
  } = useGetLessons({
    search: debouncedSearchTerm,
    locale,
    page: currentPage,
    limit,
  });

  return (
    <div>
      <Header>
        <h1>Lessons</h1>
        <Button color="primary" startIcon={<Add />} onClick={() => history.push(`${Area.CreateContent_Lessons}/new`)}>
          New lesson
        </Button>
      </Header>

      <Box mb={3} style={{ display: "flex", gap: "16px" }}>
        <LocaleSelect value={locale} onChange={setLocale} />
        <TextField
          fullWidth
          label={t("exercises.search_label")}
          variant="outlined"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          placeholder={t("exercises.search_placeholder")}
        />
      </Box>

      {isLoading && <CircularProgress />}

      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100, 200]}
        component="div"
        count={data?.metadata?.total_count}
        rowsPerPage={limit}
        page={currentPage}
        onPageChange={(event, newPage) => {
          setCurrentPage(newPage);
        }}
        onRowsPerPageChange={event => {
          setLimit(parseInt(event.target.value, 10));
          setCurrentPage(0);
        }}
      />

      <CardContainer>
        {data?.items?.map((lesson: any) => {
          const { id, title } = lesson;
          const caption = lesson.parts_count ? `${lesson.parts_count} ${t("usercourse.parts")}` : undefined;
          const image = lesson.image_url ? (
            <img alt="" src={`${lesson.image_url}`} height="100%" />
          ) : (
            <LogoIcon title="Joint Academy" />
          );

          return (
            <LibraryItem
              key={`lesson_${lesson.id}`}
              caption={caption}
              checked={false}
              id={id}
              image={image}
              tags={lesson.target_joints}
              title={title}
              onClick={() => {
                history.push(`${Area.CreateContent_Lessons}/${lesson.id}`);
              }}
            />
          );
        })}
      </CardContainer>
    </div>
  );
};
